import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import ExpandableButtonListItem from "@meetyoo/components/src/components/List/ExpandableButtonListItem";

import PMIcon from "@material-ui/icons/Phone";
import { PM_CONFERENCES_PATH } from "../../../constants/router";

const DrawerPMContent = ({ onClickFn }) => (
  <NavLink onClick={onClickFn} style={{ color: "inherit", textDecoration: "none" }} to={PM_CONFERENCES_PATH}>
    <ExpandableButtonListItem title="Conferences" icon={<PMIcon />} onClickHandler={onClickFn} />
  </NavLink>
);

DrawerPMContent.propTypes = {
  onClickFn: PropTypes.func.isRequired,
};

export default DrawerPMContent;
